module.exports = __webpack_public_path__ + "static/media/logo.2b5d9d55.svg";